import { connect } from 'react-redux';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { segmentTrack } from 'src/app/state/actions';

import { OrderTrackingRenderer } from '.';

function makeMapStateToProps() {
  return state => {
    // confusingly, this is the current pathname if there's no actual previous location.
    const previousPathname: string = state?.routerLocation?.previous?.pathname ?? '';

    return {
      previousPathname,
    };
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchSegmentTrack: (event: UnifiedEvent, payload?) => dispatch(segmentTrack(event, payload)),
  };
}

export const OrderTracking = connect(makeMapStateToProps, mapDispatchToProps)(OrderTrackingRenderer);
